module.exports = __webpack_public_path__ + "static/img/kjdy07.5422772.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/kjdy07.jpg
// module id = 1420
// module chunks = 0